import { makeApi } from "@zodios/core";

import { branded } from "@/lib/helpers/branded-helper.ts";
import { lastSoftwareUpdateDtoSchema } from "@/types/backoffice/dto/mombox/last-software-update-dto.ts";
import { momboxDtoSchema } from "@/types/backoffice/dto/mombox/mombox-dto.ts";

export const backofficeMomboxApi = makeApi([
  {
    method: "get",
    path: "/:hwId",
    alias: "findMomboxById",
    response: momboxDtoSchema,
    parameters: [
      {
        type: "Path",
        name: "hwId",
        schema: branded.pilotHwId,
      },
    ],
  },
  {
    method: "get",
    path: "/:id/last-software-update",
    alias: "findMomboxLastSoftwareUpdate",
    response: lastSoftwareUpdateDtoSchema.nullable(),
  },
]);
